import {
  get,
  post,
  getDynamicynamic,
  getFileUseBlobByPost,
} from "../request/http";

/**
 * 获取用户信息
 * @param {*} data
 * @returns
 */
export const getUserInfo = (data) =>
  post("/web/person/center/setupDataReturn", data);

/**
 * 登录
 * @param {*} data
 * @returns
 *
 * */
export const login = (data) => post("/web/sys/visitor/login", data);
/**
 * 注册
 * @param {*} data
 * @returns
 *
 * */
export const register = (data) => post("/web/sys/visitor/sign/up", data);

/**
 * 忘记密码
 * @param {*} data
 * @returns
 *
 * */
export const forgetPWD = (data) => post("/web/sys/forget/pwd", data);

/**
 * 查询国家列表
 * @param {*} data
 * @returns
 *
 * */
export const getCountryList = (data) =>
  post("/web/portal/sys/dict/get/nationality", data);

/**
 * 推送邮箱接口
 * @param {*} data
 * @returns
 *
 * */
export const emailPush = (data) => post("/web/sys/verify/email/push", data);

/**
 * 退出登录
 * @param {*} data
 * @returns
 *
 * */
export const logout = (data) => post("/web/sys/logout", data);

/**
 * 访客资料设置
 * @param {*} data
 * @returns
 *
 * */
export const setupData = (data) =>
  post("/web/person/center/visitor/setupData", data);

/**
 * 变更密码
 * @param {*} data
 * @returns
 *
 * */
export const updatePwd = (data) => post("/web/person/center/updatePwd", data);
